import {forwardRef} from 'react';
import styled from 'styled-components';

import image from '../assets/exclamation-circle-jelly-bean-100.png';

import styles from '../styles/base_components/Input.module.scss';

const Wrapper = styled.div`
  &&& input {
    ${props => props.error && `
      border: 1px solid ${props.theme.jellyBean};
      box-shadow: 0 0 5px ${props.theme.jellyBean};
    `}
  }
  
  img {
    display: ${props => props.error ? 'block' : 'none'};
  }
  
  p {
    color: ${props => props.error ? props.theme.jellyBean : props.theme.gamboge};
  }
`;

/**
 * @param {string} props.classname
 * @param {string} props.placeholder
 * @param {boolean} props.disabled
 *
 * @param {string} props.value
 * @param {function} props.setValue
 *
 * @param {string} props.error required
 * @param {function} props.setError required
 */
const Input = forwardRef((props, ref) => {  // TODO delete forwarding ref
  function onChange(event) {
    props.setValue && props.setValue(event.target.value);
    props.setError('');
  }

  function onKeyUp(event) {
    props.onKeyUp && props.onKeyUp(event);
  }

  return (
    <Wrapper className={styles.input + ' ' + props.className} error={props.error}>
      <input
        placeholder={props.placeholder}
        disabled={props.disabled}
        ref={ref}
        value={props.value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        autoFocus={props.autoFocus}
      />
      <img src={image} alt='Exclamation circle'/>
      <p>{props.error ? props.error : props.warning}</p>
    </Wrapper>
  );
});

export default Input;
